import useUserAlertsRegistration from './useUserAlertsRegistration';

export default useUserAlertsRegistration;
